import axios from '@/axiosInterceptor';

const state = () => ({
  blankContract: null,
});

// getters
const getters = {};

// actions

const actions = {
  async getBlankContract({ commit }) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/contracts/current_contract`
      );
      commit('setBlankContract', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async uploadRedlinedContract(_, { file, contractId, onboardingPacketId }) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('contract_id', contractId);
    fd.append('onboarding_packet_id', onboardingPacketId);
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/onboarding_packet_contracts/upload_redlined_contract`,
        fd
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async uploadRedlinedTaxContract(_, { file, taxFormId, onboardingPacketId }) {
    const fd = new FormData();
    fd.append('tax_form_submission[file]', file);
    fd.append('tax_form_submission[tax_form_id]', taxFormId);
    fd.append('tax_form_submission[onboarding_packet_id]', onboardingPacketId);
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/tax_form_submissions/upload_redlined_tax_contract`,
        fd
      );
      return res;
    } catch (e) {
      let status = e?.response?.status;
      if (axios.isAxiosError(e) && status && [206].includes(status)) {
        return '206';
      } else if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setBlankContract(state, contract) {
    state.blankContract = contract;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
